import Component from "@glimmer/component"
import type { Course, Unit } from "@shared/models/course"
import styles from "./unit-in-header.module.css"

interface Signature {
  Args: {
    units: Array<Unit>
    course: Course
    dateString: string
  }
}

export default class UnitInHeaderComponent extends Component<Signature> {
  readonly styles = styles
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::ClassWebsite::UnitInHeaderComponent": typeof UnitInHeaderComponent
  }
}
